<mat-dialog-content class="dialog-content">
  <h2 mat-dialog-title class="matDialogTitle"> {{ dialogTitles.FILTER_RSVP }}</h2>
  <section class="filter-section">
    <app-shared-filter
        [filterItems]="rsvpOptions"
        [formGroup]="rsvpFilterForm"
        controlName="rsvp"
      >
      </app-shared-filter>
      <app-shared-filter
        [filterItems]="universityOptions"
        [formGroup]="universityFilterForm"
        controlName="university"
      >
      </app-shared-filter>
      <app-shared-filter
        [filterItems]="dietaryRequirementOptions"
        [formGroup]="dietaryRequirementsFilterForm"
        controlName="dietaryRequirement"
      >
      </app-shared-filter>
  </section>  
</mat-dialog-content>
<mat-dialog-actions class="matDialogActions">
  <button mat-flat-button  color="accent" matDialogClose>
    {{ buttonActions.CANCEL }}
  </button>
  <button mat-flat-button  color="primary" (click)="onSubmit()">
    {{ buttonActions.SUBMIT }}
  </button>
</mat-dialog-actions>